import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'panel.'

@vsingleton()
export class PanelLayoutRoute extends RouteBase {
  prefix = ROUTE_PREFIX

  newCampaign() {
    return this.ziggyRoute('new_campaign')
  }

  switchBack() {
    return this.ziggyRoute('api.switch_back')
  }

  //---
  dashboard() {
    return this.ziggyRoute('dashboard')
  }

  //Content
  contentItemIndex() {
    return this.ziggyRoute('content.items.index')
  }

  //Support
  ticketIndex() {
    return this.ziggyRoute('support.tickets.index')
  }

  supportFaq() {
    return this.ziggyRoute('support.faqs.index')
  }

  wallet() {
    return this.ziggyRoute('wallet.index')
  }

  profile() {
    return this.ziggyRoute('profile.index')
  }

  blog() {
    return 'https://niknevis.com/academy/'
  }

}